// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".policy-text[data-v-9fa3b68e] {\n  max-height: 300px;\n  overflow-y: auto;\n}\n.title-left[data-v-9fa3b68e] {\n  display: flex;\n  flex: 1;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
